<template>
  <div class="checkBoxWrap">
    <label>
      <div class="checkBoxHint">
        <input type="checkbox"
               :true-value="trueValue"
               :false-value="falseValue"
               :name="name"
               :id="name"
               v-model="value"
               v-on:change="cdTrigger"
        >
        <div class="visualCheckBox" v-bind:class="{active:isTrue}">
          <IconBase  viewBox="0 0 12.828 8.414">
            <chekbox></chekbox>
          </IconBase>
        </div>
      </div>
      <span v-html="item.label" class="labelChb"></span>
    </label>
  </div>

</template>

<script>
  import {mapState} from 'vuex';
  import DataForInput from '@/store/Form/longFormOptions';
  export default {
    name: "fmCheckBox",
    data(){
      return {
        item:DataForInput[this.name],
      }
    },
    methods:{
      cdTrigger(){
        this.$palantir.trackInputBlur(this.name,this.valueVuex[this.name]);
      }
    },
    components:{
      chekbox:()=>import('@/components/svg/chekbox'),
      IconBase: () => import('@/components/svg/IconBase'),
    },
    computed:{
      isTrue(){
        return this.value == this.trueValue;
      },
      ...mapState({
        statusVuex: state => state.Form.workData,
        valueVuex: state => state.Form.sendData,
      }),
      value: {
        get() {
          return this.valueVuex[this.name]
        },
        set(value) {
          let utiputi = {
            target: this.name,
            value: value
          };
          this.$store.dispatch('saveSendData', utiputi);
        }
      }
    },
    props:{
      name:{
        type:String,
        default:'',
      },
      trueValue:{
        type:String,
        default: 'true'
      },
      falseValue:{
        type:String,
        default: 'false'
      },
    }
  }
</script>

<style scoped>
.checkBoxWrap{position: relative;background: rgba(255, 0, 0, 0.0);transition: 0.4s ease-out;}
.checkBoxWrap.fail{background: rgba(255, 0, 0, 0.5);}
label{display: flex;align-items: center;justify-content: center;cursor: pointer;}
label input{opacity: 0}
.visualCheckBox{width: 5vw;height: 5vw;display: flex;align-items:
  center;justify-content: center;width: 6vw;height: 6vw;border-radius: 2px;}
.visualCheckBox svg{width: 3.2vw;height: 1.9vw;opacity: 0;}
.visualCheckBox.active svg{opacity: 1;}
.checkBoxHint{position: relative;width: 13vw;height: 6vw;}
.checkBoxHint > * {position: absolute;top:0;left:0}
/deep/ .labelChb > a{color:white;}

@media screen and (min-width: 760px) {

.visualCheckBox, .checkBoxHint{width: 1.6vw;height: 1.6vw;}
  .checkBoxHint{margin-right: 1vw}
  .visualCheckBox svg{    width: 0.9vw;height: 0.6vw;}
}
@media screen and (min-width: 1140px) {
  .visualCheckBox, .checkBoxHint{width: 18px;height: 18px;}
  .checkBoxHint{margin-right: 20px;}
  .visualCheckBox svg{width: 10px;height: 6px;}
}
</style>
